module.exports = __webpack_public_path__ + "img/SWP_Shield_05.c8ce3836.png";